// VFX: Word Stagger Spring
// Category: word-reveals  ·  Tags: text, word, stagger, spring, reveal
// Words cascade in with spring easing.
import React from "react";
import {AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate} from "remotion";
const clamp = {extrapolateLeft:"clamp",extrapolateRight:"clamp"} as const;
export const WordStaggerSpring: React.FC<{
  text?: string; fontSize?: number; fontWeight?: number;
  color?: string; accentWords?: string[]; accentColor?: string;
  staggerFrames?: number; align?: "left"|"center"|"right";
}> = ({
  text="Every creator decoded", fontSize=64, fontWeight=800,
  color="#1a1a2e", accentWords=["decoded"], accentColor="#6366f1",
  staggerFrames=5, align="center"
}) => {
  const frame = useCurrentFrame();
  const {fps} = useVideoConfig();
  const words = text.split(" ");
  return (
    <AbsoluteFill style={{justifyContent:"center", alignItems:"center", padding:"0 60px"}}>
      <div style={{
        display:"flex", flexWrap:"wrap", gap:"0.25em", justifyContent:align==="center"?"center":align==="right"?"flex-end":"flex-start",
        textAlign: align as "left"|"center"|"right",
      }}>
        {words.map((word, i) => {
          const delay = i * staggerFrames;
          const p = spring({frame: frame - delay, fps, config:{damping:120, stiffness:200, mass:0.7}});
          const isAccent = accentWords?.includes(word.toLowerCase().replace(/[.,!?]/g,""));
          return (
            <div key={i} style={{
              opacity: p,
              transform:`translateY(${interpolate(p,[0,1],[30,0],clamp)}px)`,
              fontSize, fontWeight, lineHeight:1.2,
              fontFamily:"system-ui, sans-serif",
              color: isAccent ? accentColor : color,
            }}>{word}</div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};

export default function TextWordStaggerSpring800Ms() {
  return <WordStaggerSpring />;
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
